// SYM-6446: linking a campaign to an ATS job sends every candidate who applied before the
// link (SYM-6445). The user sees who before they confirm, so the backlog is no surprise.

export type WaitingCandidate = {
  procedure_id: number;
  name: string;
  applied_at: string | null;
};

export type WaitingCandidates = {
  count: number;
  candidates: WaitingCandidate[];
};

/** The warning shown under the job picker, or null when nobody is waiting. */
export const waitingCandidatesMessage = (
  waiting?: WaitingCandidates | null
): string | null => {
  const count = waiting?.count ?? 0;
  if (count <= 0) return null;

  return count === 1
    ? '1 candidate already applied to this campaign. They will be sent to your ATS when you link:'
    : `${count} candidates already applied to this campaign. They will be sent to your ATS when you link:`;
};
